import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from '../../../../hooks/useTranslation';
import MapSearchIcon from '../icons/MapSearchIcon';
import ChevronRighticon from '@material-ui/icons/ChevronRight';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import {
  ResponsivePageView,
  useOutageResponsivePageTracker,
} from '../../providers/OutageResponsivePageTracker';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      padding: theme.spacing(2.5),
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      gap: `${theme.spacing(1)}px`,
    },
    title: {
      fontWeight: 'bold',
    },
  }),
);
export const HomeView = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { setPage } = useOutageResponsivePageTracker();

  return (
    <Grid
      container
      className={classes.root}
      onClick={() => {
        setPage(ResponsivePageView.Map);
      }}
    >
      <Grid item className={classes.item}>
        <MapSearchIcon size={32} />
        <Typography className={classes.title}>
          {t('VIEW_OUTAGE_MAP_BUTTON')}
        </Typography>
      </Grid>
      <Grid item className={classes.item}>
        <ChevronRighticon />
      </Grid>
    </Grid>
  );
};
